import React from 'react';
import { ParticipantCreateDto } from '../../../../types/admin.types';
import AdminDateTimeInput from './AdminDateTimeInput';

interface ParticipantFormFieldsProps {
    form: ParticipantCreateDto;
    onChange: (next: ParticipantCreateDto) => void;
    fieldClassName: string;
    idPrefix?: string;
    requiredName?: boolean;
    showProfileImage?: boolean;
}

export const normalizeParticipantCreatePayload = (form: ParticipantCreateDto): ParticipantCreateDto => ({
    Name: (form.Name ?? '').trim(),
    Nickname: form.Nickname && form.Nickname.trim().length > 0 ? form.Nickname.trim() : null,
    ProfileImageBase64: form.ProfileImageBase64 && form.ProfileImageBase64.trim().length > 0
        ? form.ProfileImageBase64.trim()
        : null,
    DateOfBirth: form.DateOfBirth && form.DateOfBirth.trim().length > 0 ? form.DateOfBirth : null
});

const ParticipantFormFields = ({
    form,
    onChange,
    fieldClassName,
    idPrefix = 'participant',
    requiredName = true,
    showProfileImage = true
}: ParticipantFormFieldsProps) => (
    <>
        <div className={fieldClassName}>
            <label htmlFor={`${idPrefix}-name`}>Name</label>
            <input
                id={`${idPrefix}-name`}
                value={form.Name}
                onChange={(event) => onChange({ ...form, Name: event.target.value })}
                maxLength={200}
                required={requiredName}
            />
        </div>
        <div className={fieldClassName}>
            <label htmlFor={`${idPrefix}-nickname`}>Nickname</label>
            <input
                id={`${idPrefix}-nickname`}
                value={form.Nickname ?? ''}
                onChange={(event) => onChange({ ...form, Nickname: event.target.value })}
                maxLength={200}
            />
        </div>
        <div className={fieldClassName}>
            <label htmlFor={`${idPrefix}-dob`}>Date of Birth</label>
            <AdminDateTimeInput
                id={`${idPrefix}-dob`}
                value={form.DateOfBirth ?? ''}
                onChange={(value) => onChange({ ...form, DateOfBirth: value })}
            />
        </div>
        {showProfileImage ? (
            <div className={fieldClassName}>
                <label htmlFor={`${idPrefix}-image`}>Profile Image (base64)</label>
                <textarea
                    id={`${idPrefix}-image`}
                    value={form.ProfileImageBase64 ?? ''}
                    onChange={(event) => onChange({ ...form, ProfileImageBase64: event.target.value })}
                />
            </div>
        ) : null}
    </>
);

export default ParticipantFormFields;
